import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { businessActions } from './redux/slices/businessSlice';
import { resolveBusinesses } from './config/businesses';
import InvalidSubdomainError from './components/common/InvalidSubdomainError';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import DefaultTheme from './styles/DefaultTheme';

const businesses = resolveBusinesses(window.location.hostname);

// ✅ MANEJO DE SUBDOMINIO INVÁLIDO
if (businesses.length === 0) {
  // ✅ RENDERIZAR COMPONENTE DE ERROR PARA SUBDOMINIO INVÁLIDO
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={DefaultTheme}>
        <CssBaseline />
        <InvalidSubdomainError hostname={window.location.hostname} />
      </ThemeProvider>
    </React.StrictMode>
  );

  // ✅ NO CONTINUAR CON LA RENDERIZACIÓN DE LA APP
  reportWebVitals();
} else if (businesses.length === 1) {
  store.dispatch(
    businessActions.login({
      ...businesses[0],
      availableBusinesses: businesses,
    })
  );
} else if (businesses.length > 1) {
  store.dispatch(businessActions.login({ availableBusinesses: businesses }));
}

// ✅ SOLO RENDERIZAR LA APP SI HAY BUSINESSES VÁLIDOS
if (businesses.length > 0) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more about https://bit.ly/CRA-vitals
reportWebVitals();
